import store from '../store'

export default function(segmentId) {
  return store.state.user.segmentsList.find(el => +el.id === +segmentId).title
}